// extracted by css-extract-rspack-plugin
export default {"drawerBody":"MY5zSyXmIfQfU66a__drawerBody___"};